import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { getScrollbarWidth } from '../../../lib/helpers';
import {IShelfDivider} from '../../../infrastructure/interfaces'
import {getShelfDividers, editShelfDivider} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import { contentImagesRelativePath } from '../../../constants';
import {TooltipCont} from "../../../infrastructure/tooltips";
import ShelfDividerEditorModal from "../../Modals/ShelfDividerEditorModal/ShelfDividerEditorModal";

export interface IManageFullPageCatalogImagesProps {
    shelfDividers?: IShelfDivider[];
    editShelfDivider(divider: IShelfDivider, formData: FormData): void;
    getShelfDividers(): void;
    onCreate(): void;
}

export interface IManageFullPageCatalogImagesState {
    selectedShelfDivider?: IShelfDivider;
    showShelfDividerEditorModal: Boolean
}

const mapStateToProps = (state: any) => {
    return {
        shelfDividers: state.shelfDividerList,
    };
};

const mapDispatchToProps = (dispatch: any): any => {
    return {
        getShelfDividers: () => {
            dispatch(getShelfDividers());
        },
        editShelfDivider: (divider: IShelfDivider, formData: FormData) => {
            dispatch(editShelfDivider(divider, formData));
        }
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageShelfDividersTable extends React.Component<IManageFullPageCatalogImagesProps, IManageFullPageCatalogImagesState> {
    tableRow: HTMLElement;
    constructor(props: IManageFullPageCatalogImagesProps) {
        super(props);
        this.state = {
            showShelfDividerEditorModal: false
        };

        // Bind methods
        this.closeModals = this.closeModals.bind(this)
        this.editShelfDivider = this.editShelfDivider.bind(this)
    }

    componentDidMount() {
        this.props.getShelfDividers();
    }

    onEditShelfDivider(divider: IShelfDivider) {
        this.setState({
            selectedShelfDivider: divider,
        }, () => this.setState({
            showShelfDividerEditorModal: true,
        }));
    }

    editShelfDivider(divider: IShelfDivider, formData: FormData) {
        this.props.editShelfDivider(divider, formData)
    }

    closeModals() {
        this.setState({
            showShelfDividerEditorModal: false,
            selectedShelfDivider: undefined
        });
    }

    render() {

        const {
            shelfDividers,
        } = this.props;
        const nonNullShelfDividers = shelfDividers ? shelfDividers : [];

        return (
            <div className="root-container">
                <HeaderBar />
                <div className="inner-su-container">
                    <div className="manage-items-row">

                    <div className="in-row-text-container">
                        Manage Shelf Divider Pages
                    </div>
                    </div>
                    <table className="table-scrollableSU documents-table">
                        <thead style={{ paddingRight: getScrollbarWidth() }}>
                        <tr>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody className="document-table-body">
                            {nonNullShelfDividers.map((t: IShelfDivider) =>

                            <tr key={t.id} ref={tr => this.tableRow = tr!}>
                                <td>
                                    {t.category.name}
                                </td>
                                <td>
                                    <img
                                        hidden={t.image_path.length <= 1}
                                        className="inlineImagesTableImage"
                                        src={contentImagesRelativePath + t.image_path}
                                    />
                                </td>
                                <td>
                                    <div className="button-wrapper">
                                        <button
                                            className="btn primary-blue"
                                            onClick={() => {
                                                this.onEditShelfDivider(t)
                                            }}
                                            title={TooltipCont.EDIT}
                                            disabled={false}
                                        >
                                             Edit
                                        </button>
                                    </div>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <ShelfDividerEditorModal
                    show={this.state.showShelfDividerEditorModal}
                    selectedDivider={this.state.selectedShelfDivider}
                    onClose={this.closeModals}
                    onSubmit={(divider: IShelfDivider, formData: FormData) => {
                            this.editShelfDivider(divider, formData);
                            this.closeModals();
                        }
                    }
                />
            </div>
        );
        }
    }



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageShelfDividers.tsx